<template>
  <div>
    <custom-actions>
      <template #header>
        <el-button type="primary" @click="showForm(null)">新增</el-button>
      </template>
      <el-form :model="searchForm" ref="formData" inline class="global-form-label-width account-form"
        label-width="100px">
        <el-form-item label="姓名" prop="userName">
          <el-input clearable v-model="searchForm.userName" placeholder="姓名" />
        </el-form-item>

        <el-form-item label="成品油类型" prop="oliType">
          <el-select v-model="searchForm.oliType" clearable>
            <el-option :value="item.oilType" :label="item.oilTypeName" v-for="(item, index) of typeList"
              :key="index"></el-option>
          </el-select>
        </el-form-item>

        <el-form-item label="开始计价日期" prop="ygDate">
          <el-date-picker v-model="searchForm.ygDate" format="yyyy-MM-dd" value-format="yyyy-MM-dd" type="date"
            placeholder="请选择开始计价日期">
          </el-date-picker>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="onSearch">查询</el-button>
          <el-button @click="onReset">重置</el-button>
        </el-form-item>
      </el-form>
    </custom-actions>

    <el-card shadow="never" class="mt10">
      <el-table size="mini" stripe border v-loading="loading" :data="tableData">

        <el-table-column min-width="120" label="客户" prop="userName"></el-table-column>
        <el-table-column min-width="120" label="成品油类型" prop="oilTypeName"></el-table-column>
        <el-table-column min-width="120" label="剩余库存" prop="ygNumber"></el-table-column>
        <el-table-column min-width="120" label="每日/单价" prop="unitPrice"></el-table-column>
        <el-table-column min-width="120" label="单位" prop="ygUnitName"></el-table-column>
        <el-table-column min-width="120" label="开始计价日期" prop="ygDate"></el-table-column>
        <el-table-column min-width="120" label="合同金额" prop="ygPrice"></el-table-column>
        <el-table-column width="250" label="操作" fixed="right">
          <template v-slot="{ row }">
            <el-button type="text" @click="$router.push('/cpyManage/edit?ygId=' + row.ygId)">编辑</el-button>
            <el-button type="text" @click="$router.push('/cpyManage/detail?ygId=' + row.ygId)">详情</el-button>
            <el-button type="text" @click="deleteYgNumber(row.ygId)">删除库存</el-button>
          </template>
        </el-table-column>
      </el-table>

      <el-pagination class="mt15" :current-page.sync="page" background layout="total, prev, pager, next" :total="total"
        @current-change="loadData">
      </el-pagination>
    </el-card>
  </div>
</template>

<script>
import keepAlive from '@/mixins/keepAlive'
export default {
  name: 'AccountManage',
  mixins: [keepAlive],
  data () {
    return {
      activeType: '1',
      tableData: [],
      roles: [],
      ygUnitList: [],
      typeList: [],
      page: 1,
      total: 0,
      loading: false,
      searchForm: {
        userName: '',
        oliType: '',
        ygDate: ''
      },
      dialogVisible: false
    }
  },
  created () {
    this.loadData()
    // this.loadRoles()
    this.loadOliTypeList()
  },
  computed: {
    deptData () {
      return this.$store.state.deptList
    }
  },
  methods: {
    loadOliTypeList () {
      this.$axios.get(this.$apis.oiltabkManage.selectYgOilTypeByPage).then(res => {
        this.typeList = res.list
      })
    },
    loadRoles () {
      this.$axios.get(this.$apis.system.selectSysRoleByList).then(res => {
        this.roles = res
      })
    },
    closeCascader () {
      this.$refs.cascader.dropDownVisible = false
    },
    loadData () {
      const params = {
        page: this.page,
        ...this.searchForm
      }
      console.log('params', params)
      this.$axios.get(this.$apis.oiltabkManage.selectYgUserInventoryByList, {
        params: params
      }).then(res => {
        this.tableData = res.list
        this.total = res.total
      })
    },
    onSearch () {
      this.page = 1
      this.loadData()
    },
    onReset () {
      this.$refs.formData.resetFields()
    },
    showForm () {
      this.$router.push('/cpyManage/add')
    },
    deleteYgNumber (ygId) {
      this.$confirm('确认删除该库存?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.$axios.post(this.$apis.oiltabkManage.deleteYgUserInventory, {
          ygId
        }).then(() => {
          this.loadData()
        })
      })
    }

  }
}
</script>

<style scoped lang='scss'>
// .el-select {
//   width: 100%;
// }</style>
<style lang='scss'>
.account-form {

  .el-select,
  .el-input,
  .el-cascader {
    width: 200px !important;
  }
}
</style>
